<template>
	<div style="padding: 1em">
		<v-snackbar
			v-model="snackbar"
			:timeout="5000"
			:top="true"
			color="accent"
			class="black--text"
		>
			{{ snackbarText }}
			<v-btn class="blexon-button" small icon @click="snackbar = false">
				<v-icon>close</v-icon>
			</v-btn>
		</v-snackbar>
		<h1>Arbeitsplätze</h1>
		<v-form v-model="formValid" ref="form">
			<div
				v-for="(workplace, index) in workplaces"
				:key="index"
				class="workplace"
				:class="getClass(workplace)"
				:title="getTitle(workplace)"
			>
				<h2>{{ workplace.displayName }}</h2>
				<v-text-field
					label="Arbeitsgangname"
					hint="Name des Arbeitsgangs in Oseon"
					v-model="workplace.workStepName"
					@change="updateWorkplace(workplace)"
				>
				</v-text-field>
				<v-text-field
					label="Arbeitsplatzname oder ArbeitsplatzGruppenname"
					hint="Name des Arbeitsplatzes oder der Arbeitsplatzgruppe in Oseon"
					v-model="workplace.workplaceName"
					@change="updateWorkplace(workplace)"
				>
				</v-text-field>
			</div>
		</v-form>
	</div>
</template>

<script>
import httpClient from "../store/httpClient";
import manufacturingWorkStepTypes from "../dtos/manufacturingWorkStepTypes";

export default {
	data() {
		return {
			isLoading: false,
			snackbar: false,
			snackbarText: "",
			formValid: false,
			workplanNameRule: [(v) => v.length <= 50 || "Max. 50 Zeichen"],
			workplaces: manufacturingWorkStepTypes,
		};
	},

	mounted() {
		this.loadWorkplaces();
		this.$refs.form.validate();
	},

	computed: {
		fertiger() {
			var fertigerId = this.$route.params.fertigerId;
			var currentFertiger = this.$store.state.fertiger.filter((f) => f.id == fertigerId);
			return currentFertiger[0];
		},
	},
	methods: {
		getTitle(workplace) {
			if (!workplace.workplaceName || !workplace.workStepName) {
				return "Wird nicht angeboten. Falls der Arbeitsschritt angeboten werden soll, muss für den Arbeitsgang und den Arbeitsplatz ein Name eingetragen werden.";
			} else {
				return "Verfügbar";
			}
		},
		getClass(workplace) {
			if (workplace.workplaceName && workplace.workStepName) {
				return "available";
			}
		},
		async loadWorkplaces() {
			var fertigerId = this.$route.params.fertigerId;
			const response = await httpClient().get(
				`api/Fertiger/GetWorkplaces?fertigerId=${fertigerId}`
			);
			for (const workplace of response.data) {
				const localWorkplace = this.workplaces.find(
					(w) => w.manufacturingWorkStepType === workplace.manufacturingWorkStepType
				);
				localWorkplace.workplaceName = workplace.workplaceName;
				localWorkplace.workStepName = workplace.workStepName;
			}
		},
		async updateWorkplace(workplace) {
			workplace.workplaceName = workplace.workplaceName.trim();
			workplace.workStepName = workplace.workStepName.trim();
			var fertigerId = this.$route.params.fertigerId;
			await httpClient().post(
				`api/Fertiger/UpdateWorkplace?fertigerId=${fertigerId}`,
				workplace
			);
			this.setSnackbarText("Änderung erfolgreich gespeichert");
		},
		setSnackbarText(text) {
			this.snackbarText = text;
			this.snackbar = true;
		},
	},
};
</script>

<style scoped>
td {
	min-width: 140px;
}
td.name {
	width: 100%;
}
form {
	display: flex;
	flex-wrap: wrap;
}
.workplace {
	width: 400px;
	border: 2px solid orange;
	border-radius: 4px;
	box-shadow: 2px 2px lightgray;
	margin-right: 1em;
	margin-top: 1em;
	padding: 1em;
}
.workplace.available {
	border: 2px solid green;
}
</style>
